import { render, staticRenderFns } from "./CRMCustomerTocase.vue?vue&type=template&id=4533e0c5&scoped=true&"
import script from "./CRMCustomerTocase.vue?vue&type=script&lang=js&"
export * from "./CRMCustomerTocase.vue?vue&type=script&lang=js&"
import style0 from "./CRMCustomerTocase.vue?vue&type=style&index=0&id=4533e0c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4533e0c5",
  null
  
)

export default component.exports